import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'arrow-badge-left', 'ArrowBadgeLeft', [["path",{"d":"M11 17h6l-4 -5l4 -5h-6l-4 5z","key":"svg-0"}]]);